import React from 'react';

const MetalIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" fill="none" {...rest}>
      <path d="M10.2868 1L16.2344 5.712L17.4017 9.47284L11.8384 10.5356L5.37805 4.64614L6.75026 1.8273L10.2868 1Z" stroke="#6D7885" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M6.74976 1.82739L12.4619 6.72086" stroke="#6D7885" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M11.8385 10.5355L12.4624 6.48162L16.2345 5.71191M11.7009 13.0526L12.8661 16.6616L6.91345 17.8217L1 12.0286L2.31002 8.77186L5.09216 8.12399" stroke="#6D7885" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.31006 8.77197L7.77137 13.9371" stroke="#6D7885" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M6.91345 17.5599L7.87431 13.6181L11.6999 13.0635" stroke="#6D7885" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.7443 12.3315L16.2921 15.9975L21 15.0795L20.0035 11.6072L16.7443 12.3315Z" stroke="#6D7885" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
};

export default MetalIcon;